export default "__VITE_ASSET__BguoG_1t__"